import type { IconType } from 'react-icons';
import {
  MdArchitecture,
  MdBolt,
  MdDescription,
  MdGridView,
  MdImage,
  MdLayers,
  MdPrecisionManufacturing,
  MdScience,
  MdStraighten,
  MdViewInAr,
} from 'react-icons/md';

// A manifest names a token, never a component or a path: manifests may
// eventually be authored by customers, and naming an icon must not be a way to
// load anything.
const ICONS: Readonly<Record<string, IconType>> = {
  architecture: MdArchitecture,
  bolt: MdBolt,
  description: MdDescription,
  grid_view: MdGridView,
  image: MdImage,
  layers: MdLayers,
  precision_manufacturing: MdPrecisionManufacturing,
  science: MdScience,
  straighten: MdStraighten,
  view_in_ar: MdViewInAr,
};

export const FALLBACK_ICON: IconType = MdGridView;

export const iconFor = (token: string | null | undefined): IconType =>
  (token ? ICONS[token] : undefined) ?? FALLBACK_ICON;
